import Logo from "@assets/icon/something-wrong.svg";

const ErrorIcon = () => {
  return <img src={Logo} alt={Logo} />;
};

export default ErrorIcon;
